import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

// Public pages
import Contact from "./pages/Contact";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import Services from "./pages/Services";
import Industries from "./pages/Industries";
import Products from "./pages/Products";
import Security from "./pages/Security";
import Careers from "./pages/Careers";
import BookDemo from "./pages/BookDemo";
import Login from "./pages/Login";

// Public Blog Routes
import Blog from "./pages/Blog";
import BlogDetailPage from "./pages/BlogDetailPage";

// Protected routing + layout
import ProtectedRoute from "./routes/ProtectedRoute";
import DashboardLayout from "./pages/Dashboard";

// Admin Dashboard pages
import Reports from "./pages/dashboard/Reports";
import AdminProducts from "./pages/dashboard/AdminProducts";
import DashBlogs from "./pages/dashboard/AdminBlogs";
import Leads from "./pages/dashboard/AdminLeads";
import Employees from "./pages/dashboard/AdminEmployees";
import Expenses from "./pages/dashboard/AdminExpenses";
import Sales from "./pages/dashboard/AdminSales";
import Orders from "./pages/dashboard/AdminOrders";
import Earning from "./pages/dashboard/AdminEarning";
import Profile from "./pages/dashboard/AdminProfile";
import Contacts from "./pages/dashboard/AdminContacts";
import AdminCareers from "./pages/dashboard/AdminCareers";
import DemoRequests from "./pages/dashboard/AdminDemoRequests";
import Contributions from "./pages/dashboard/AdminContributions";
import AdminReviews from "./pages/dashboard/AdminReviews";



// TEMP placeholders (keep if you already use them)
const Work = () => <div className="p-4">💼 Our Work</div>;
const Software = () => <div className="p-4">💻 Software Development</div>;
const Hostel = {
  default: () => <div className="p-4">🏨 Hostel & Library Booking</div>,
}.default;

function AppRoutes() {
  const location = useLocation();

  // Hide website Navbar/Footer ONLY on dashboard routes
  const isDashboardRoute = location.pathname.startsWith("/dashboard");
  const hideWebsiteLayout = isDashboardRoute;

  return (
    <div className="min-h-screen flex flex-col">
      {/* Navbar visible on ALL public pages + login */}
      {!hideWebsiteLayout && <Navbar />}

      <div className="flex-1">
        <Routes>
          {/* Public */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/services" element={<Services />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/products" element={<Products />} />
          <Route path="/security" element={<Security />} />
          <Route path="/work" element={<Work />} />
          <Route path="/software" element={<Software />} />
          <Route path="/hostel" element={<Hostel />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/book-demo" element={<BookDemo />} />

          {/* Public Blog */}
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogDetailPage />} />

          {/* Auth */}
          <Route path="/login" element={<Login />} />

          {/* Protected Dashboard */}
          <Route element={<ProtectedRoute />}>
            <Route path="/dashboard" element={<DashboardLayout />}>
              <Route
                index
                element={<Navigate to="/dashboard/reports" replace />}
              />

              <Route path="reports" element={<Reports />} />
              <Route path="products" element={<AdminProducts />} />
              {/* Blogs module */}
              <Route path="blogs" element={<DashBlogs />} />
              <Route path="blogs/new" element={<DashBlogs />} />
              <Route path="blogs/:id" element={<DashBlogs />} />

              <Route path="leads" element={<Leads />} />
              <Route path="employees" element={<Employees />} />
              <Route path="expenses" element={<Expenses />} />
              <Route path="contributions" element={<Contributions />} />

              {/* Admin Panel Modules */}
              <Route path="contacts" element={<Contacts />} />
              <Route path="careers" element={<AdminCareers />} />
              <Route path="demorequests" element={<DemoRequests />} />

              <Route path="sales" element={<Sales />} />
              <Route path="orders" element={<Orders />} />
              <Route path="earning" element={<Earning />} />
              <Route path="profile" element={<Profile />} />
              <Route path="reviews" element={<AdminReviews />} />
            </Route>
          </Route>

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>

      {/* Footer visible on ALL public pages + login */}
      {!hideWebsiteLayout && <Footer />}
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}
